'use client';

import { faFilter } from '@fortawesome/pro-light-svg-icons';

import { ModalFilterByLetter } from './modal-filter-by-letter.component';

import { useModal } from '@/hooks/use-modal.hook';
import { Button } from '@/components/ui/button/button.component';
import { Icon } from '@/components/ui/icon.component';
import { Pill } from '@/components/ui/pill/pill.component';
import { EntityByLetterCount } from '@/types/professional/professional-by-letters.types';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface ModalFilterNetworkProps {
  selectedLetter?: string;
  count: EntityByLetterCount;
}

export function ModalFilterNetwork({
  selectedLetter,
  count,
}: ModalFilterNetworkProps) {
  const { open, onOpenChange } = useModal();
  const letterUpper = selectedLetter?.toUpperCase();

  return (
    <>
      <div className="mt-4 sm:mt-5">
        <Pill
          variant={selectedLetter ? 'success' : 'light'}
          icon={faFilter}
          asChild
          data-test-id="filter-letter--network-list"
        >
          <Button
            className="flex items-center gap-1 hover:no-underline"
            variant="text"
            data-analytics-event={selectedLetter ?? AnalyticsEnum.CLICK_OPEN_MODAL_PARTNERS_INDEX}
            onClick={() => {
              onOpenChange(true);
            }}
          >
            {selectedLetter
              ? (
                  <>
                    <Icon icon={faFilter} className="text-success-800" />

                    <Typography
                      variant={TypographyVariant.MEDIUM_BODY_TEXT}
                      className="text-success-700 font-semibold"
                    >
                      Letra
                      {' '}
                      {letterUpper}
                    </Typography>
                  </>
                )
              : (
                  <>
                    <Icon icon={faFilter} className="text-gray-800" />
                    <Typography
                      variant={TypographyVariant.MEDIUM_BODY_TEXT}
                      className="text-gray-700 font-semibold"
                    >
                      Filtrar por letra
                    </Typography>
                  </>
                )}
          </Button>
        </Pill>
      </div>

      <ModalFilterByLetter
        open={open}
        onOpenChange={onOpenChange}
        selectedLetter={letterUpper}
        count={count}
      />
    </>
  );
}
